import React from 'react';

import styles from './style.module.scss';

const BlackBackdrop = ({ children }) => <div className={styles.container}>{children}</div>;

export default BlackBackdrop;
